import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import { MDCMenuSurface, Corner } from '@material/menu-surface';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-calendar-setting-bar', {
  mixins: [eventListenerMixin],

  properties: {
    updateUrl: String,
  },

  connected() {
    this.colorSetting = this.querySelector('.setting-item.setting-color');
    this.colorMenuSurfaceRoot = document.querySelector('.mdc-menu-surface.color-selector-menu');

    this.initSettingMenuSurface();
    this.initColorMenuSurface();

    this.listenTo(
      this.querySelector('.tr-button.menu-surface-anchor'),
      'click', () => {
        this.toggleOpen();
      },
    );
    this.listenTo(this.settingMenuSurface, {
      'MDCMenuSurface:opened': () => { this.originData = this.getSubmitValues(); },
      'MDCMenuSurface:closed': this.handleSettingMenuSurfaceClosed.bind(this),
    });
    this.listenTo(this, 'tr-switch-field:change', this.handleSwitchFieldChange.bind(this));
    this.listenTo(this.colorSetting, {
      mouseover: this.handleColorSettingMouseover.bind(this),
      mouseleave: this.handleColorSettingMouseleave.bind(this),
    });
    this.listenTo(this.colorMenuSurfaceRoot, 'click', this.handleMenuItemSelected.bind(this));
  },

  handleMenuItemSelected(event) {
    if (closest(event.target, '.mdc-list-item')) {
      const everSelectedItem = document.querySelector('.color-selector-menu .mdc-list-item--selected');
      const selectedItem = closest(event.target, '.mdc-list-item');
      if (everSelectedItem !== selectedItem) {
        $(everSelectedItem).removeClass('mdc-list-item--selected');
        $(selectedItem).addClass('mdc-list-item--selected');
        this.colorSetting.setAttribute('data-value', selectedItem.getAttribute('data-value'));
        const fieldKey = selectedItem.getAttribute('data-key') || '';
        this.colorSetting.setAttribute('data-key', fieldKey);
        this.namespacedTrigger('change', {
          detail: {
            target: 'color',
            value: selectedItem.getAttribute('data-value'),
          },
          bubbles: true,
        });
        this.toggleOpen(false);
      }
    }
  },

  handleColorSettingMouseover() {
    if (!this.colorMenuSurface.open) {
      this.colorMenuSurface.hoistMenuToBody();
      this.colorMenuSurface.open = true;
    }
  },

  handleColorSettingMouseleave(event) {
    const toMenuSurface = $.contains(this.colorMenuSurfaceRoot, event.relatedTarget)
      || (this.colorMenuSurfaceRoot === event.relatedTarget);
    if (!toMenuSurface && this.colorMenuSurface.open) {
      this.colorMenuSurface.open = false;
    }
  },

  handleSwitchFieldChange(e) {
    if (closest(e.target, '.show-assignee-avatar')) {
      this.namespacedTrigger('change', {
        detail: {
          target: 'avatar',
        },
        bubbles: true,
      });
    } else if (closest(e.target, '.show-lunar-calendar')) {
      this.namespacedTrigger('change', {
        detail: {
          target: 'lunarCalendar',
        },
        bubbles: true,
      });
    } else if (closest(e.target, '.show-holidays')) {
      this.namespacedTrigger('change', {
        detail: {
          target: 'holidays',
        },
        bubbles: true,
      });
    }
  },

  initSettingMenuSurface() {
    const menuSurfaceRoot = this.querySelector('.mdc-menu-surface.setting-menu');
    this.settingMenuSurface = new MDCMenuSurface(menuSurfaceRoot);
    this.settingMenuSurface.setAnchorCorner(Corner.BOTTOM_RIGHT);
    this.settingMenuSurface.setMenuSurfaceAnchorElement(this);
  },

  initColorMenuSurface() {
    this.colorMenuSurface = new MDCMenuSurface(this.colorMenuSurfaceRoot);
    this.colorMenuSurface.setAnchorCorner(Corner.BOTTOM_RIGHT);
    this.colorMenuSurface.setMenuSurfaceAnchorElement(this.colorSetting);
  },

  handleSettingMenuSurfaceClosed() {
    const data = this.getSubmitValues();

    if (JSON.stringify(data) !== JSON.stringify(this.originData)) {
      $.ajax({
        url: this.updateUrl,
        type: 'put',
        data,
        dataType: 'script',
      });
    }
  },

  getSubmitValues() {
    const settings = {};
    Array.from(this.querySelectorAll('.setting-item')).forEach((item) => {
      if (item.querySelector('tr-switch-field')) {
        const { checked: enabled } = item.querySelector('tr-switch-field');
        settings[item.dataset.key] = enabled;
      }
    });
    settings.todo_color = this.colorSetting.getAttribute('data-value');
    settings.field_key = this.colorSetting.getAttribute('data-key');
    return settings;
  },

  toggleOpen(open = !this.settingMenuSurface.open) {
    this.settingMenuSurface.open = open;
    if (this.colorMenuSurface.open) this.colorMenuSurface.open = false;
  },

  disconnected() {
    this.stopListening();
    if (this.settingMenuSurface) this.settingMenuSurface.destroy();
    if (this.colorMenuSurface) {
      this.colorSetting.insertAdjacentElement('beforeend', this.colorMenuSurfaceRoot);
      this.colorMenuSurface.destroy();
    }
  },
});
